import UntitledIcon, { TIconName } from '@payaca/untitled-icons';
import React, { FunctionComponent, useState, type JSX } from 'react';
import BasicField from '../basicField/BasicField';
import { InputStyleVariant } from '../inputWrapper/InputWrapper';
import './PrivateField.sass';

type Props = {
  styleVariant?: InputStyleVariant;
  name: string;
  value?: any;
  label?: string | JSX.Element;
  description?: string | JSX.Element;
  isDisabled?: boolean;
  isRequired?: boolean;
  iconBefore?: TIconName;
  additionalInputProps?: { [key: string]: any };
  changeTimeoutMs?: number;
  onChange?: (value: { [key: string]: string }) => void;
  onTouch?: (fieldName: string) => void;
  onBlur?: () => void;
  onChangeTimeout?: () => void;
};

const PrivateField: FunctionComponent<React.PropsWithChildren<Props>> = (
  props: React.PropsWithChildren<Props>
): JSX.Element => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div className={`private-field`}>
      <BasicField
        type={isVisible ? 'text' : 'password'}
        {...props}
        iconAfter={
          <UntitledIcon
            onClick={() => setIsVisible((isVisible) => !isVisible)}
            name={isVisible ? 'eye-off.3' : 'eye.3'}
          />
        }
      />
    </div>
  );
};

export default PrivateField;
